<script lang="ts">
    import ReactionButton from '$components/Reaction/ReactionButton.svelte';
    import { useFragment } from '$gql/fragment-masking.js';
    import { ReactionFragmentDoc, type FeedCommentFragment } from '$gql/graphql.js';
    import { getContainer } from '$components/Context/ContainerContext';

    export let comment: FeedCommentFragment;

    $: reaction = useFragment(ReactionFragmentDoc, comment.reaction);

    let currentUserId = getContainer().currentUserStore().currentUserId();
</script>

<ReactionButton
    {reaction}
    target={{ feedCommentId: comment.id }}
    author={{ userId: $currentUserId }}
    hideButtonLabel
/>
